import React, { useState } from 'react';
import { Button, Paper, Typography } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import GetAppIcon from '@material-ui/icons/GetApp';
import AssistedAffiliationFilterBar from './components/AssistedAffiliationFilterBar';
import AssistedAffiliationTable from './components/AssistedAffiliationTable';
import { EMPTY_FILTERS } from './constants';
import { SAMPLE_REQUESTS } from './mocks/assistedAffiliationRequests';
import type { AssistedAffiliationFilters, AssistedAffiliationRncScreenProps } from './types';
import useStyle from './styles';

// Los botones de cabecera y las acciones por fila quedan sin funcionalidad a propósito: cada
// flujo se conecta en su propio ticket.
const AssistedAffiliationRncScreen = ({ readOnly }: AssistedAffiliationRncScreenProps) => {
  const classes = useStyle();
  const [filters, setFilters] = useState<AssistedAffiliationFilters>(EMPTY_FILTERS);

  // Único punto de consulta: al existir el endpoint, `filters` viaja en la petición y la respuesta
  // sustituye al fixture aquí, sin tocar los hijos. Filtrar en el front sería falso: filtra el servidor.
  const requests = SAMPLE_REQUESTS;

  return (
    <Paper className={classes.paper} elevation={1}>
      <div className={classes.header}>
        <Typography variant="h5" component="h2" className={classes.title}>
          Afiliación Asistida
        </Typography>
        <div className={classes.headerActions}>
          <Button
            variant="contained"
            className={classes.primaryButton}
            startIcon={<AddIcon />}
            disabled={readOnly}
          >
            Nueva Solicitud
          </Button>
          <Button
            variant="outlined"
            className={classes.secondaryButton}
            startIcon={<GetAppIcon />}
          >
            Exportar
          </Button>
        </div>
      </div>

      <AssistedAffiliationFilterBar filters={filters} onFiltersChange={setFilters} />

      <AssistedAffiliationTable requests={requests} readOnly={readOnly} />
    </Paper>
  );
};

export default AssistedAffiliationRncScreen;
